import { debounce, throttle } from "quasar";

export default function({ Vue, configuration }) {
    /**
     * 防抖 防止重复点击
     * 传参：v-debounceClick="() =>{ handleFun(arg) }"
     * 不传参:v-debounceClick="handleFun"
     * delayTime:延迟的时间,只执行最后一次
     */
    Vue.directive('debounceClick', {
        inserted: function (el, binding) {
            let delayTime = el.getAttribute('delay-time') || configuration.debounceTime
            el.onclick = debounce(function () {
                binding.value()
            }, delayTime)
        },
    })

    Vue.directive('throttleClick', {
        inserted: function (el, binding) {
            let delayTime = el.getAttribute('delay-time') || configuration.throttleTime
            el.onclick = throttle(function () {
                binding.value()
            }, delayTime)
        },
    })

}
